<template>
  <div id="content" class="container">
    <header>
      <div class="integralBreadcrumb">
        <div
          class="integralBreadcrumb-item"
          @click="routerHandle('onlineTraining')"
        >
          首页
        </div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item" style="cursor: default">
          在线报名
        </div>
        <!-- @click="routerHandle('signUp')" -->
      </div>
      <div class="certificate-con">
        <el-form
          ref="dataForm"
          :model="dataForm"
          :rules="dataRule"
          size="medium"
          label-width="400px"
        >
          <el-form-item label="报名课程：" prop="liveCourseName">
            <el-input
              clearable
              v-model="dataForm.liveCourseName"
              placeholder="请输入"
              class="width-400"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="userName">
            <el-input
              clearable
              v-model="dataForm.userName"
              placeholder="请输入"
              maxlength="20"
              class="width-400"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司："
                        prop="enterpriseName">
            <el-input clearable v-model="dataForm.enterpriseName "
                      placeholder="请输入"
                     class="width-400"></el-input>
                     <!-- :disabled="true" -->
          </el-form-item>
          <el-form-item label="性别：" prop="sex" fill="#1D65A8">
            <el-radio v-model="dataForm.sex" label="1">男</el-radio>
            <el-radio v-model="dataForm.sex" label="2">女</el-radio>
          </el-form-item>
          <el-form-item label="期数：" prop="periodsNumber" v-if="type==2">
            <el-select
              placeholder="请选择"
              class="width-400"
              v-model="dataForm.periodsNumber"
            >
              <el-option
                v-for="item in timeOptions"
                :label="item"
                :value="item"
                :key="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="认证信息："
            v-if="
              certProgramFormList.length > 0 &&
              (type == 1 || (type == 2 && qualification == 1))
            "
            prop="certProgramFormList"
          >
            <el-table
              @selection-change="handleSelectionChange"
              :data="certProgramFormList"
              border
              class="width-500"
            >
              <el-table-column type="selection" width="50"> </el-table-column>
              <el-table-column prop="programName" label="认证项目">
              </el-table-column>
              <el-table-column prop="trainType" label="认证资格" width="170">
                <template scope="scope">
                  <el-radio-group v-model="scope.row.trainType">
                    <el-radio :label="0">初评</el-radio>
                    <el-radio :label="1">复评</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="岗位/职务：" prop="post">
            <el-input
              clearable
              v-model="dataForm.post"
              placeholder="请输入"
              class="width-400"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input
              clearable
              v-model="dataForm.mobile"
              placeholder="请输入"
              class="width-400"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱：" prop="email">
            <el-input
              clearable
              v-model="dataForm.email"
              placeholder="请输入"
              class="width-400"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址：" prop="address">
            <el-input
              clearable
              v-model="dataForm.address"
              placeholder="请输入"
              class="width-400"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮编：" prop="postCode">
            <el-input
              clearable
              v-model="dataForm.postCode"
              placeholder="请输入"
              class="width-400"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传附件：" :class="{ 'is-required': type !='2' }" prop="fileOssId">
            <UploadFile
              :limit="3"
              :beforeUpload="beforeUpload"
              :accept="'.jpg,.jpeg,.png,.gif,.bmp,.xls,.xlsx,.doc,.docx,.csv,.txt,.pdf,.zip,.rar,.ppt,.pptx'"
              tip="上传图片和文件格式，文件最大为10M"
              @onSuccess="onSuccess"
            />
          </el-form-item>
          <el-form-item label="价格：" v-if="type==2">
            <span style="color: red;">￥{{activityPrice}}</span>
          </el-form-item>
          <el-form-item prop="classify">
            <el-button
              type="primary"
              plain
              style="
                background: #1d65a8;
                border: 1px solid #1d65a8;
                color: #fff;
              "
              @click="submit"
              :loading="butLoading"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </header>
  </div>
</template>
<script>
import { isMobile, isPhone } from '@/utils/validate'
import Cookies from 'js-cookie'
import UploadFile from '@/components/upload/file'

export default {
  components: {
    UploadFile
  },
  data () {
    var validateMobile = (rule, value, callback) => {
      if (!this.dataForm.mobile) {
        callback(new Error('联系方式不能为空'))
      } else if (
        !isMobile(this.dataForm.mobile) &&
        !isPhone(this.dataForm.mobile)
      ) {
        callback(new Error('联系方式格式错误'))
      } else {
        callback()
      }
    }
    var validatePostCode = (rule, value, callback) => {
      if (value && !/^[0-9]{6}$/.test(value)) {
        callback(new Error('邮编为6位数组'))
      } else {
        callback()
      }
    }
    return {
      butLoading: false,
      dataForm: {
        userId: '',
        liveCourseId: this.$route.query.id,
        liveCourseName: this.$route.query.title,
        userName: '',
        sex: '1', // 性别 1:男2:女
        enterpriseName: this.$store.state.user.defaultCompanyName || '',
        post: '', // 职位
        mobile: '',
        email: '',
        address: '',
        postCode: '',
        certProgramFormList: null, // 认证项目
        periodsNumber: '',
        fileOssId: '' // 上传附件
      },
      certProgramFormList: [],
      dataRule: {
        userName: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        enterpriseName: [
          { required: true, message: '请维护企业信息', trigger: 'blur' }
        ],
        postCode: [{ validator: validatePostCode, trigger: 'blur' }],
        mobile: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        periodsNumber: [
          { required: true, message: '请选择期数', trigger: 'blur' }
        ],
        certProgramFormList: [
          {
            type: 'array',
            required: true,
            message: '请选择认证项目',
            trigger: 'change'
          }
        ],
        fileOssId: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ]
      },
      multipleSelection: []
    }
  },
  created () {
    this.getListTrainProgram()
    if (Number(this.$route.query.type) === 2) {
      Reflect.deleteProperty(this.dataRule, 'fileOssId')
    }
  },
  mounted () {
    // 查看课程
    this.dataForm.userId = Cookies.get('userId')
    this.dataForm.enterpriseName = this.$store.state.user.defaultCompanyName
    if (Number(this.$route.query.type) !== 2) {
      this.dataForm.userName = this.$store.state.user.userName // this.userName
    }
    this.dataForm.mobile = this.mobile
  },
  computed: {
    courseId () {
      return this.$route.query.id
    },
    courseName () {
      return this.$route.query.title
    },
    enterpriseName () {
      return this.$store.state.user.defaultCompanyName || ''
    },
    // userName () {
    //   return Cookies.get('username') || this.dataForm.userName
    // },
    mobile () {
      return Cookies.get('mobile') || this.dataForm.mobile
    },
    type () {
      return this.$route.query.type || '1'
    },
    qualification () {
      let qualification = this.$route.query.qualification
      return Number(qualification) === 0 ? 0 : 1
    },
    activityPrice () {
      return (Number(this.$route.query.activityPrice) || 0).toFixed(2)
    },
    timeOptions () {
      if (this.$route.query.liveTime) {
        return this.$route.query.liveTime.split(',')
      } else {
        return []
      }
    }
  },
  watch: {
    // userName (val) {
    // this.dataForm.userName = this.val
    // },
    mobile (val) {
      this.dataForm.mobile = this.val
    },
    enterpriseName (val) {
      this.dataForm.enterpriseName = this.val
    }
  },
  methods: {
    // 获取认证项目
    getListTrainProgram () {
      let id = this.$route.query.id
      this.$http
        .get(`/front/train/trainOnlineUser/listTrainProgram/${id}`, {})
        .then(({ data: res }) => {
          let certProgramFormList = res.data
          certProgramFormList.forEach((item) => {
            item.trainType = 0
          })
          this.certProgramFormList = certProgramFormList
        })
    },
    // 报名列表
    getCourseList () {
      this.$http
        .get(`/help/train/trainOfflineCourse/selectAllOfflineCourseList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.courseList = res.data
          }
        })
    },
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'signUp') {
        this.$router.push({ name: 'signUpForm' })
      }
    },
    // 提交
    submit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.butLoading = true
          this.dataForm.userId = Cookies.get('userId')
          // this.dataForm.enterpriseName = this.enterpriseName
          this.$http
            .post(`/front/train/trainOnlineUser/save`, {
              ...this.dataForm,
              activityPrice: this.activityPrice || 0,
              qualification: this.qualification
            })
            .then(({ data: res }) => {
              if (res.code === 0) {
                this.$message({
                  message: '报名成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.butLoading = false
                  }
                })
                if (Number(this.type) === 2 && Number(this.activityPrice)) {
                  this.$router.replace({ name: 'settlement', query: { goodsId: this.courseId, type: 6 } })
                } else {
                  this.$router.replace('/liveNotice')
                }
              } else {
                // this.$message.error(res.msg || '报名成功')
                this.butLoading = false
              }
            })
            .catch(() => {})
        }
      })
    },
    // 提交前先验证
    beforeUpload (file) {
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      return isLt10M
    },
    // 上传成功需要修改input值
    onSuccess (arr) {
      this.dataForm.fileOssId = arr.join(',')
      this.$refs.dataForm.validateField('fileOssId')
    },
    // 勾选表格
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.dataForm.certProgramFormList = val
    }
  }
}
</script>
<style scoped lang="scss">
.certificate-con {
  width: 100%;
  min-height: 400px;
  background: #fff;
  padding-top: 30px;
  padding-bottom: 30px;
}
.reg-line-r-yzm:hover {
  background: #0f3e6a;
}
.reg-line-r-yzm {
  position: absolute;
  width: 100px;
  height: 34px;
  color: #fff;
  line-height: 34px;
  text-align: center;
  background: #1d65a8;
  right: 450px;
  top: 0px;
  cursor: pointer;
}
.width-400 {
  width: 400px;
}
.width-500 {
  width: 500px;
}
</style>
